export default (errorCode) => {

    // Define Error Message
    let errors = [
        {'original': 'aws.cognito.UserNotFound', 'custom': 'Login Failed, User not found'},
        {'original': 'aws.cognito.UserNotAuthorized', 'custom': 'Login Failed, Invalid Password'},
        {'original': 'aws.cognito.UserNotConfirmed', 'custom': 'Please check your inbox for your Validation Email - TONE Networks'},
        {'original': 'aws.cognito.PasswordReset', 'custom': 'Login Failed, Password Reset is required'},
        {'original': 'User.Requested.Not.Found', 'custom': 'User not found'},
        {'original': 'User.Exists', 'custom': 'User Already Exists'},
        {'original': 'aws.cognito.Authorized', 'custom': 'You are successfully logged in'},
        {'original': 'request.failed', 'custom': 'An error occurred while processing the request'}
    ];

    // Filter if message exists
    let exists = errors.filter(item => item.original.toLowerCase() === errorCode.toLowerCase());

    //Return message
    if (exists.length) return exists[0].custom;
    else return errorCode;
};



// WEBPACK FOOTER //
// ./src/helpers/appErrors.js